import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';
import AgeGate from './components/AgeGate';
import Header from './components/Header';
import Footer from './components/Footer';
import InseratePage from './pages/InseratePage';
import ListingDetail from './pages/ListingDetail';
import PlaceholderPage from './pages/PlaceholderPage';
import AdminPage from './pages/AdminPage';
import ProfilePage from './pages/ProfilePage';
import FavoritesPage from './pages/FavoritesPage';
import CityLandingPage from './pages/CityLandingPage';

const Layout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

function App() {
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage.getItem('dm_age_verified') === 'true') {
      setVerified(true);
    }
  }, []);

  const handleAccept = () => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('dm_age_verified', 'true');
    }
    setVerified(true);
  };

  return (
    <div className="App min-h-screen bg-[#0f0a0c] text-white">
      <BrowserRouter>
        <AuthProvider>
          <FavoritesProvider>
            {!verified && <AgeGate onAccept={handleAccept} />}
            <Routes>
              <Route path="/" element={<Navigate to="/inserate" replace />} />
              <Route path="/inserate" element={<Layout><InseratePage /></Layout>} />
              <Route path="/inserate/:slug" element={<Layout><ListingDetail /></Layout>} />
              <Route path="/sex-inserate/:slug" element={<Layout><CityLandingPage /></Layout>} />
              <Route path="/favoriten" element={<Layout><FavoritesPage /></Layout>} />
              <Route path="/clubs" element={<Layout><PlaceholderPage title="Clubs" subtitle="Übersicht der Schweizer Clubs — in Kürze verfügbar." /></Layout>} />
              <Route path="/jobs" element={<Layout><PlaceholderPage title="Stellen & Jobs" subtitle="Jobinserate werden hier in Kürze angezeigt." /></Layout>} />
              <Route path="/immobilien" element={<Layout><PlaceholderPage title="Immobilien" subtitle="Immobilien-Inserate werden hier in Kürze angezeigt." /></Layout>} />
              <Route path="/admin" element={<Layout><AdminPage /></Layout>} />
              <Route path="/mein-profil" element={<Layout><ProfilePage /></Layout>} />
            </Routes>
          </FavoritesProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
